import { render, staticRenderFns } from "./GradeEdit.vue?vue&type=template&id=947cb324&scoped=true"
import script from "./GradeEdit.vue?vue&type=script&lang=js"
export * from "./GradeEdit.vue?vue&type=script&lang=js"
import style0 from "./GradeEdit.vue?vue&type=style&index=0&id=947cb324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947cb324",
  null
  
)

export default component.exports